module.exports = __webpack_public_path__ + "static/img/5.304149f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/5.png
// module id = 337L
// module chunks = 0